<h2>Falhas de exportação</h2>

<form class="form-b4a fail-export__group-by">
  <label class="fail-export__group-by-label" for="fail-export-group-by">
    Agrupar por
  </label>
  <p-selectButton
    inputId="fail-export-group-by"
    [options]="groupByOptions"
    [formControl]="groupByControl"
    optionLabel="label"
    optionValue="value"
    (onChange)="onGroupByChange()"
  />
</form>

<div>
  <ng-container *ngIf="!isGrouped && failExport && detailCols">
    <app-table
      [elements]="failExport"
      [addButton]="false"
      [cols]="detailCols"
      emptyMessage="Nenhuma falha de exportação encontrada."
      [exportExcel]="false"
      [exportPdf]="false"
      [lazy]="false"
      sortField="dateCreated"
      [sortOrder]="1"
      [changeColumns]="true"
      [showTitle]="false"
      modelName="registros"
    ></app-table>
  </ng-container>

  <ng-container *ngIf="isGrouped && failExport && groupCols">
    <app-table
      [elements]="groupedFailExport"
      [addButton]="false"
      [cols]="groupCols"
      [expansionCols]="detailCols"
      expandField="failures"
      dataKey="groupKey"
      [expansionLazy]="false"
      [expandPaginator]="false"
      emptyMessage="Nenhuma falha de exportação encontrada."
      [exportExcel]="false"
      [exportPdf]="false"
      [lazy]="false"
      sortField="groupLabel"
      [sortOrder]="1"
      [changeColumns]="false"
      [showTitle]="false"
      modelName="grupos"
    ></app-table>
  </ng-container>
</div>
